import React from "react";
import "./ShirdiShaniShingnapurPackage.css";

const itinerary = [
  {
    step: "01",
    title: "Pune to Shirdi",
    places: ["Pune", "Shirdi"],
    note: "Early morning departure from Pune",
  },
  {
    step: "02",
    title: "Shirdi Sai Baba Darshan",
    places: ["Shirdi", "Sai Baba Temple"],
    note: "Sai Baba Temple darshan",
  },
  {
    step: "03",
    title: "Shani Shingnapur Darshan",
    places: ["Shirdi", "Shani Shingnapur"],
    note: "Visit Shani Shingnapur Temple",
  },
  {
    step: "04",
    title: "Return to Pune",
    places: ["Shani Shingnapur", "Pune"],
    note: "Same-day return to Pune",
  },
];

const vehicles = [
  {
    name: "Sedan Cab",
    price: "₹6,199",
    icon: "🚘",
  },
  {
    name: "Ertiga Cab",
    price: "₹7,499",
    icon: "🚙",
  },
  {
    name: "Kia Carens",
    price: "₹8,899",
    icon: "🚗",
  },
  {
    name: "Innova Crysta",
    price: "₹9,999",
    icon: "🚐",
    popular: true,
  },
];

export default function ShirdiShaniShingnapurPackage() {
  return (
    <section className="ss-package">
      <div className="ss-container">

        {/* HEADER */}
        <div className="ss-header">

          <div className="ss-logo-box">
            <img
              src="/images/logo.jpg"
              alt="Garud Cabs"
              className="ss-logo"
            />
          </div>

          <div className="ss-header-content">

            <span className="ss-badge">
              SAME DAY RETURN • DARSHAN PACKAGE
            </span>

            <h1>
              Pune to Shirdi & Shani Shingnapur
              <span> Cab Package</span>
            </h1>

            <p>
              Book a comfortable Commercial Cab from Pune for Shirdi
              Sai Baba and Shani Shingnapur Darshan with convenient
              same-day return to Pune.
            </p>

          </div>

        </div>


        {/* ROUTE */}
        <div className="ss-route">

          <span className="ss-route-label">
            DARSHAN ROUTE
          </span>

          <div className="ss-route-text">
            Pune
            <b>→</b>
            Shirdi Sai Baba
            <b>→</b>
            Shani Shingnapur
            <b>→</b>
            Pune
          </div>

        </div>


        {/* MAIN CONTENT */}
        <div className="ss-main-grid">

          {/* DARSHAN PLAN */}
          <div className="ss-card">

            <div className="ss-section-heading">

              <div className="ss-heading-icon">
                🙏
              </div>

              <div>
                <small>SAME DAY TRAVEL PLAN</small>
                <h2>Shirdi & Shani Shingnapur Darshan</h2>
              </div>

            </div>


            <div className="ss-timeline">

              {itinerary.map((item) => (

                <div
                  className="ss-timeline-item"
                  key={item.step}
                >

                  <div className="ss-step">
                    {item.step}
                  </div>

                  <div className="ss-day-content">

                    <h3>{item.title}</h3>

                    <div className="ss-places">

                      {item.places.map((place, index) => (
                        <React.Fragment key={place}>

                          <span>{place}</span>

                          {index !== item.places.length - 1 && (
                            <b>→</b>
                          )}

                        </React.Fragment>
                      ))}

                    </div>

                    <div className="ss-note">
                      ✓ {item.note}
                    </div>

                  </div>

                </div>

              ))}

            </div>

          </div>


          {/* RIGHT SIDE */}
          <div className="ss-side">

            {/* PACKAGE DETAILS */}
            <div className="ss-card ss-details">

              <span className="ss-mini-label">
                PACKAGE DETAILS
              </span>

              <h2>Same Day Darshan Tour</h2>

              <div className="ss-detail-row">
                <span>Starting Point</span>
                <strong>Pune</strong>
              </div>

              <div className="ss-detail-row">
                <span>First Darshan</span>
                <strong>Shirdi Sai Baba</strong>
              </div>

              <div className="ss-detail-row">
                <span>Second Darshan</span>
                <strong>Shani Shingnapur</strong>
              </div>

              <div className="ss-detail-row">
                <span>Duration</span>
                <strong>Same Day</strong>
              </div>

              <div className="ss-detail-row">
                <span>Return</span>
                <strong>Pune</strong>
              </div>

              <div className="ss-detail-row">
                <span>Tour Type</span>
                <strong>Commercial Cab</strong>
              </div>

            </div>


            {/* HIGHLIGHTS */}
            <div className="ss-card ss-highlights">

              <span className="ss-mini-label">
                DARSHAN HIGHLIGHTS
              </span>

              <div className="ss-highlight-grid">

                <div>
                  <span>✓</span>
                  Pune Pickup
                </div>

                <div>
                  <span>✓</span>
                  Shirdi Darshan
                </div>

                <div>
                  <span>✓</span>
                  Shani Shingnapur
                </div>

                <div>
                  <span>✓</span>
                  Commercial Cab
                </div>

                <div>
                  <span>✓</span>
                  Same Day Trip
                </div>

                <div>
                  <span>✓</span>
                  Pune Return
                </div>

              </div>

            </div>


            {/* SPECIAL NOTE */}
            <div className="ss-special-note">

              <div className="ss-note-icon">
                ॐ
              </div>

              <div>
                <strong>
                  Two Famous Darshan Destinations
                </strong>

                <p>
                  Visit Shirdi Sai Baba Temple and Shani Shingnapur
                  comfortably in a Commercial Cab from Pune.
                </p>
              </div>

            </div>

          </div>

        </div>


        {/* PRICE SECTION */}
        <div className="ss-pricing">

          <div className="ss-pricing-heading">

            <div>
              <span className="ss-mini-label">
                CHOOSE YOUR CAB
              </span>

              <h2>
                Same Day Darshan Package Price
              </h2>
            </div>

            <p>
              Pune → Shirdi → Shani Shingnapur → Pune
            </p>

          </div>


          <div className="ss-vehicle-grid">

            {vehicles.map((vehicle) => (

              <div
                className={`ss-vehicle-card ${
                  vehicle.popular ? "ss-popular" : ""
                }`}
                key={vehicle.name}
              >

                {vehicle.popular && (
                  <span className="ss-popular-tag">
                    POPULAR
                  </span>
                )}

                <div className="ss-vehicle-icon">
                  {vehicle.icon}
                </div>

                <div className="ss-vehicle-info">

                  <h3>{vehicle.name}</h3>

                  <small>
                    Same Day Package
                  </small>

                </div>

                <div className="ss-price">
                  {vehicle.price}
                </div>

              </div>

            ))}

          </div>

        </div>


        {/* BOOKING */}
        <div className="ss-booking">

          <div>

            <span>
              GARUD CABS • PUNE
            </span>

            <h2>
              Book Shirdi & Shani Shingnapur Darshan
            </h2>

            <p>
              Same Day Return • Commercial Cab • Comfortable Journey
            </p>

          </div>

          <a
            href="tel:+919970007784"
            className="ss-book-btn"
          >
            Book Your Cab →
          </a>

        </div>

      </div>
    </section>
  );
}